import { render, staticRenderFns } from "./CreateContent.vue?vue&type=template&id=06d8072f&"
import script from "./CreateContent.vue?vue&type=script&lang=js&"
export * from "./CreateContent.vue?vue&type=script&lang=js&"
import style0 from "./CreateContent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports